<template>
  <nav class="active-filters">
    <p class="title">AKTYWNE FILTRY</p>
    <div
      class="filter-block"
      v-if="selected.car_brand != '' && selected.car_brand"
    >
      <span>{{ selected.car_brand }}</span>
      <img
        src="../assets/icons/close.svg"
        class="icon"
        @click="
          () => {
            selected.car_brand = '';
            this.$parent.getOffers();
          }
        "
      />
    </div>
    <div
      class="filter-block"
      v-if="selected.car_model != '' && selected.car_model"
    >
      <span>{{ selected.car_model }}</span>
      <img
        src="../assets/icons/close.svg"
        class="icon"
        @click="
          () => {
            selected.car_model = '';
            this.$parent.getOffers();
          }
        "
      />
    </div>
    <div class="filter-block" v-if="selected.auction_name != null">
      <span>{{ selected.auction_name.toUpperCase() }}</span>
      <img
        src="../assets/icons/close.svg"
        class="icon"
        @click="
          () => {
            selected.auction_name = '';
            this.$parent.getOffers();
          }
        "
      />
    </div>
  </nav>
</template>





<script>
import Multiselect from "vue-multiselect";
import axios from "axios";
export default {
  name: "ActiveFilters",
  data() {
    return {
      selected: this.$parent.selected,
    };
  },
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.active-filters {
  background: #fff;
  display: flex;
  padding: 18px 19px 20px;
  margin: auto;
  gap: 20px;
  height: 40px;
  cursor: pointer;
  margin-bottom: 50px;
  align-items: center;
}
.title {
  font-size: 14px;
  color: #011f68;
}
.filter-block {
  font-size: 13px;
  background-color: #ebedf6;
  padding: 5px 20px;
  height: 20px;
  font-weight: bold;
  color: #011f68;
  display: flex;
  align-items: center;
  gap: 5px;
}
img {
  height: 12px;
}
</style>







